import React, { useState } from 'react';
import { ArrowRightIcon, CalendarIcon, PackageIcon } from 'lucide-react';
import { ORDERS, ORDER_STATUS_META } from '../../data/orders';
import { OrderStatus } from '../../types';
import { formatPrice } from '../../utils/format';
const FILTERS: {
  id: OrderStatus | 'todos';
  label: string;
}[] = [{
  id: 'todos',
  label: 'Todos'
}, {
  id: 'pendiente',
  label: 'Pendiente'
}, {
  id: 'proceso',
  label: 'En proceso'
}, {
  id: 'enviado',
  label: 'Enviado'
}, {
  id: 'entregado',
  label: 'Entregado'
}];
export function OrdersSection() {
  const [filter, setFilter] = useState<OrderStatus | 'todos'>('todos');
  const orders = filter === 'todos' ? ORDERS : ORDERS.filter(o => o.status === filter);
  return <section className="border border-white/8 bg-ink-700" data-id="element-385" data-mp="23chcmiuv7vk7">
      <div className="flex flex-col gap-4 border-b border-white/8 p-5" data-id="element-386" data-mp="6inob0d2icj9">
        <div data-id="element-387" data-mp="6gtae607rkoo">
          <h2 className="font-display text-2xl uppercase tracking-wide text-white" data-id="element-388" data-mp="1jt6a0mxcs07">
            Pedidos
          </h2>
          <p className="mt-1 text-xs text-white/40" data-id="element-389" data-mp="yqoy9j6wmbtp">
            {orders.length} pedidos en este filtro
          </p>
        </div>
        <div role="tablist" aria-label="Filtrar pedidos por estado" className="flex flex-wrap gap-2" data-id="element-390" data-mp="12tl7ijak0vkz">
          {FILTERS.map(f => <button key={f.id} type="button" role="tab" aria-selected={filter === f.id} onClick={() => setFilter(f.id)} className={`border px-4 py-2 text-[11px] font-bold uppercase tracking-[0.14em] transition-colors ${filter === f.id ? 'border-pink-500 bg-pink-500 text-white' : 'border-white/10 text-white/50 hover:border-white/40 hover:text-white'}`} data-id="element-391" data-mp="trbzq16o7gba">
              {f.label}
            </button>)}
        </div>
      </div>

      <ul className="divide-y divide-white/5" data-id="element-392" data-mp="257k4885nx1pl">
        {orders.map(order => {
        const meta = ORDER_STATUS_META[order.status];
        return <li key={order.id} className="flex flex-col gap-4 p-5 transition-colors hover:bg-white/[0.02] lg:flex-row lg:items-center" data-id="element-393" data-mp="2f0wqew0oquij">
              <div className="min-w-0 flex-1" data-id="element-394" data-mp="2539z1a279aho">
                <div className="flex flex-wrap items-center gap-3" data-id="element-395" data-mp="2141441vfb6kj">
                  <p className="font-display text-xl leading-none text-white" data-id="element-396" data-mp="215ubxkhrvwu4">
                    {order.id}
                  </p>
                  <span className={`border px-2.5 py-1 text-[10px] font-bold uppercase tracking-[0.12em] ${meta.className}`} data-id="element-397" data-mp="1rd6gou6fy0xi">
                    {meta.label}
                  </span>
                </div>
                <p className="mt-2 text-sm text-white" data-id="element-398" data-mp="1hhbu5nz3jlpg">{order.customer}</p>
                <p className="text-xs text-white/35" data-id="element-399" data-mp="1dcvptr54smcc">{order.email}</p>
              </div>

              <div className="flex flex-wrap items-center gap-6 text-xs text-white/45" data-id="element-400" data-mp="18ekipo680pxt">
                <span className="flex items-center gap-2" data-id="element-401" data-mp="3k2pd76niwb8e">
                  <CalendarIcon className="h-3.5 w-3.5" data-id="element-402" data-mp="3k4a8iyhnvy7b" /> {order.date}
                </span>
                <span className="flex items-center gap-2" data-id="element-403" data-mp="3p3dc0ehztwd6">
                  <PackageIcon className="h-3.5 w-3.5" data-id="element-404" data-mp="3t3x9jj6hb1zu" /> {order.items}{' '}
                  {order.items === 1 ? 'ítem' : 'ítems'}
                </span>
              </div>

              <div className="flex items-center justify-between gap-5 lg:w-56 lg:justify-end" data-id="element-405" data-mp="31c7wk0fyt63e">
                <span className="font-display text-2xl leading-none text-white" data-id="element-406" data-mp="35d04mqd3p4y3">
                  {formatPrice(order.total)}
                </span>
                <button type="button" className="group flex items-center gap-2 border border-white/15 px-4 py-2.5 text-[10px] font-bold uppercase tracking-[0.14em] text-white/70 transition-colors hover:border-pink-500 hover:text-white" data-id="element-407" data-mp="3aatdxs9paf2l">
                  Ver detalle
                  <ArrowRightIcon className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5" data-id="element-408" data-mp="2mkpapm0fchc4" />
                </button>
              </div>
            </li>;
      })}
      </ul>
    </section>;
}